<template>
  <div class="add_new_row add_new_row_btns flex desk-w-100">
    <div class="add_new_row_col1">
      <a
        class="add_task_width add_new_task flex flex--start"
        href="javascript:void(0)"
        @click="$emit('addBlock')"
      >
        <span class="plus-circ flex flex--content--center">
          <span class="plus"></span>
        </span>
        הוספת רשומה
      </a>
      <span v-if="isSurgInfo" class="surg-side-note text--20">
        בבחירת קוד פעולה זהה, יש לבחור 'צד'.
        <br />
        לתשומת ליבך: זמן הניתוח הינו זמן ברוטו, לא "זמן סכין".
      </span>
    </div>
    <div class="add_new_row_col2 desk-hide">
      <a
        v-show="isOnEdit"
        class="add_new_task flex flex--end"
        href="javascript:void(0)"
        @click.prevent="$emit('removeSelectedBlock')"
      >
        <span class="trash"><TrashSvg /></span> מחיקה
      </a>
    </div>
    <div class="error-message" v-if="errMsg.show">
      {{ errMsg.msg }}
    </div>
  </div>
</template>

<script>
import TrashSvg from "@/assets/img/svg/trash.svg";

export default {
  name: "ActionsMsgRow",
  components: { TrashSvg },
  props: {
    errMsg: { required: true },
    isOnEdit: { required: true, default: false },
    isSurgInfo: { default: false }
  }
};
</script>
